/* Collezione di tutti gli url richiamabili tramite le api */
/* Lì dove nell'url sono necessari dei parametri questi sono stati riportati
   con la "@" come segnaposto e devono essere sostituiti a runtime con il replace */

const apiUrl = {

    // Api per l'autenticazione
    authapi : {
        // Primo step dell'autenticazione a due fattori, torna il check
        // token da inviare poi indietro insieme al codice OTP ricevuto.
        // Indica anche se l'OTP verrà ricevuto via mail o via authenticator,
        // dipende da come è stato configurato l'utente.
        // Deve essere chiamata inviando la stringa base64 corretta.
        get_token : '/api/api-token-ckey/',


        // Primo step dell'autenticazione se viene effettuato un sso da un
        // applicativo Centro Paghe.
        // Dato il token di autenticazione ne viene verificata la legittimità tramite
        // Centro Paghe, se il token è valido e legato ad un utente Welfarebit torna
        // allora indietro il check token e la modalità di ricezione dell'OTP,
        // come per la chiamata api-token-ckey
        ssocp_token : '/api/api-token-ssocp/',

        // Secondo step dell'autenticazione a due fattori, inviando il codice
        // OTP ricevuto nella prima fase torna o il codice QR per il primo arruolamento
        // con l'utenticatore, oppure se l'utente era già registrato, torna il token
        // di sessione.
        otp_verify : '/api/api-token-otp/',

        // Nella fase di arruolamento del QR Code con l'autenticatore, permette all'utente
        // di confermare la corretta configurazione della app e quindi di associare il
        // secret generato al suo utente.
        auth_confirm : '/api/api-token-confirm/',

        // Permette di loggarsi con la funzione "ricollegati" del backoffice.
        // I dati utente sono inviati in maniera criptata al backend.
        backoffice_reconnection : '/api/backoffice-reconnection/',

        // Informazioni complete sull'utente. Da richiamare subito dopo il login.
        // Questa chiamata fa parte del set di chiamate dedicate al login ma richiede
        // di essere già autenticati, cioè di avere già un token valido per essere
        // chiamata.
        get_logged_user_info : '/api/get-logged-user-info/',

    },

    // Api per la gestione delle password utente
    userapi : {
        // Api per avviare il recupero della password smarrita, invia una mail
        // con il link di recupero all'utente, devono quindi essere inviati:
        // - user_email: email dell'utetente che ha smarrito la password
        // - customer: il customer attualente attivo in interfaccia
        // - interface_url: il base url dell'interfaccia
        // customer e interface url servono per costruire il link di recupero
        // per l'email che viene inviata.
        password_lost : '/api/userapi/password_lost/',

        // Api per finalizzare la procedura di recupero della password smarrita,
        // lavora in due modi:
        // - GET: Verifica soltanto se il token passato come parameto ( token_hash )
        //        esiste, torna un 204_NO_CONTENT in caso affermativo.
        // - POST:Oltre a richiamare l'url con il token deve essere fornito in post
        //        il parametro "new_password" cioè la password utente da reimpostare.
        //        Se tutto ok fornisce la data di scadenza  della nuova password ( pass_expiry_date )
        password_lost_reset : '/api/userapi/password_lost_reset/@token_hash/',

        // Api per cambiare la password utente quando questa è scaduta, segue la stessa
        // procedura della password perduta, inviando quindi via mail all'utente un link
        // per rimpostare una nuova password con nuova scadenza.
        password_expired_renew : '/api/userapi/password_expired_renew/',

        // Api per finalizzare la procedura di modifica di una password scaduta,
        // lavora in due modi:
        // - GET: Verifica soltanto se il token passato come parameto ( token_hash )
        //        esiste, torna un 204_NO_CONTENT in caso affermativo.
        // - POST:Oltre a richiamare l'url con il token deve essere fornito in post
        //        il parametro "new_password" cioè la password utente da reimpostare.
        //        Se tutto ok fornisce la data di scadenza  della nuova password ( pass_expiry_date )
        password_expired_reset : '/api/userapi/password_expired_reset/@token_hash/',

        // Api per la modifica della password utente dall'interno dell'interfaccia ( richiede quindi
        // che l'utente sia autenticato )
        // La richiesta deve essere inviata in POST e deve includere:
        // - old_passwd: la password attuale da sostituire
        // - new_passwd: la nuova password
        // - passwd_confirm: conferma della nuova password
        // Se la richiesta va a buon fine torna un oggetto json con la scadenza della nuova password
        // ( pass_expiry_date ).
        password_change : '/api/userapi/password_change/'

    },

    // Api per la gestione delle informazioni del modulo di partita doppia
    pdoppiaapi : {
        // Torna il credito attuale dell'utente, passare il parametro date_stop in
        // GET ed in formato YYYY-MM-GG HH:MM:SS per avere il calcolo del credito
        // ad una certa data, es: pdoppiaapi/credito_utente/?date_stop=2020-08-04 00:00:00
        credito_utente : '/api/pdoppiaapi/credito_utente/',

        // Restituisce lo storico delle transazioni per l'utente loggato o per
        // la sua azienda ( dipendentemente dal valore del parametro entity
        // che può essere "utente" od "azienda" ).
        // Opzionalmente possono essere forniti in get tre parametri:
        // - date_start: specifica la data di inizio delle transazioni
        // - date_stop:  specifica la data di fine delle transazioni
        // - download:   non torna il json ma scarica lo storico come un file csv
        storico_transazioni : '/api/pdoppiaapi/get_storico_transazioni/@entity/',

        // Torna le informazioni dettagliate in merito allo stato dei crediti
        // ATTIVI ( credito contabile, credito spendibile ) per lo user
        //  correntemente loggato basandosi sui calcoli del LiteBridge.
        get_user_credit_info: '/api/pdoppiaapi/get_user_credit_info/',

        // Torna le chiavi prodotte per l'azienda di cui l'utente loggato
        // ( referente aziendale ) fa parte
        // Nella querysting, usando la paginazione, possono essere usati i parametri:
        // - page: per richiedere una specifica pagina
        // - page_size: per specificare il numero di elementi da includere
        //              in una pagina.
        get_chiavi_pubbliche : '/api/pdoppiaapi/get_chiavi_pubbliche/',

        // Aggiunge la chiave pubblica passatogli associandola all'azienda
        // dell'utente ( solitamente il referente aziendale ) loggato
        add_chiave_pubblica : '/api/pdoppiaapi/add_chiave_pubblica/',

        // Cancella la chiave pubblica il cui id viene passato nell'url
        // della richiesta
        delete_chiave_pubblica : '/api/pdoppiaapi/delete_chiave_pubblica/@keyid/'

    },

    // Api per interagire con il modulo di invio delle email e di archivio dei messaggi
    mailapi : {
        // Invia la mail di assistenza verso il backoffice. Di fatto viene utilizzato solo per il
        // form di assistenza.
        send_support_mail : '/api/mailapi/send_support_mail/',

        // Torna le notifiche welfarebit per l'utente loggato.
        // Si tratta di una get che utilizza il paginatore per questo prende nella querystring
        // le due variabili page e page_size.
        notifiche_utente_list : '/api/mailapi/notifiche_utente_list/',

        // Torna un oggetto json con le statiche sulle notifiche per l'utente loggato
        // quali: numero messaggi inviati, numero messaggi ricevuti, messaggi ricevuti
        // da leggere.
        info_notifiche : '/api/mailapi/info_notifiche/',

        // Marca la notifica il cui id viene indicato nell'url come letta.
        // La notifica deve avere come DESTINATARIO l'utente collegato, torna un
        // 404_NOT_FOUND se la notifica non viene trovata, o 204_NO_CONTENT altrimenti.
        marca_notifica_come_letta : '/api/mailapi/marca_notifica_come_letta/@mess_id/',

        // Marca tutte le notifiche dell'utente come lette. Torna un 204_NO_CONTENT ad
        // operazione effettuata. Se le notifiche sono già tutte marcate come lette l'operazione
        // non ha nessun effetto.
        marca_tutte_le_notifiche_come_lette : '/api/mailapi/marca_tutte_le_notifiche_come_lette/',

        // POST per inviare messaggi nel sistema di notifiche interno da parte del referente
        // aziendale. Le i destinatari nel messaggio sono verificati sull abase dell'azienda
        // per la quale il referente sta operando.
        // La chiamata prende i parametri:
        // - destinatari : lista degli id dei destinatari
        // - messaggio   : messaggio da inviare, può essere in testo semplice od un HTML
        //                 da editor WYSIWYG.
        invia_comunicazione_interna : '/api/mailapi/invia_comunicazione_interna/'
    },

    // Api per interagire con il modulo che gestisce le informazioni archiviate.
    archivioapi : {

        // Torna le notifiche welfarebit archiviate per l'utente loggato.
        // Si tratta di una get che utilizza il paginatore per questo prende nella querystring
        // le due variabili page e page_size.
        archivio_notifiche_list : '/api/archivioapi/archivio_notifiche/',

        // Marca la notifica archiviata il cui id viene indicato nell'url come letta.
        // La notifica deve avere come DESTINATARIO l'utente collegato, torna un
        // 404_NOT_FOUND se la notifica non viene trovata, o 204_NO_CONTENT altrimenti.
        marca_notifica_archiviata_come_letta : '/api/archivioapi/marca_notifica_archiviata_come_letta/@mess_id/',

        // Marca tutte le notifiche archiviate dell'utente come letteg.
        // Torna un 204_NO_CONTENT ad operazione effettuata. Se le notifiche sono già tutte
        // marcate come lette l'operazione non ha nessun effetto.
        marca_notifiche_archiviate_come_lette : '/api/archivioapi/marca_notifiche_archiviate_come_lette/'

    },

    // Api che espone un collezione di link statici relativi ai tutorial e alla documentazione
    staticlinks : {
        // Torna la lista dei link divisi per gruppo ( sarebbero le aree temtiche ). Ltype è
        // il tipo di link voluto che al momento può essere o "tutorial" per i filmati dei
        // tutorial oppure "documentazione" per i link relativi alla documentazione.
        list_links : '/api/staticlinksapi/list_links/@ltype/',

        // Torna un link specifico per la sezione "documentazione" o "tutorial", passando oltre
        // al nome della tipologia ( ltype ), lo slug_name della risorsa voluta.
        get_link : '/api/staticlinksapi/get_link/@ltype/@slug_name/'
    },

    // Api di gestione della parte welfare
    welfareapi : {

        // Download file piani welfare
        piani_welfare_download : '/api/welfareapi/get_piani_welfare/@id/crediti',

        // Elenco delle relazioni parentali definite nel sistema
        relazioni_par : '/api/welfareapi/relazioni_par/',

        // Elengo dei beneficiari trovati per l'utente con il codice fiscale passato
        get_beneficiari : '/api/welfareapi/get_beneficiari/@cod_fisc/',

        // Elenco categorie di acquisto del sistema
        acq_categ : '/api/welfareapi/acq_categ/',

        // Categoria per kind di acquisto
        acq_categ_kind : '/api/welfareapi/acq_categ/@kind/',

        // Anagrafica fornitore ricerca per termine ( @term: "p_iva" o "cod_fisc" )
        anagrafica_fornitore_by_term: '/api/welfareapi/get_anagrafica/fornitore/@term/@term_val/',

        // Richiesta delle voci di menù abilitate per l'utente loggato
        get_menu_perms: '/api/welfareapi/get_menu_perms/',

        // Ricerca degli iban dell'utente loggato, eventualmente limitati con parametro GET "limit"
        search_iban_utente : '/api/welfareapi/search_iban_utente/@iban/',

        // Ricerca di un fondo pensione tramite covip istituto o codice covip
        search_fondo : '/api/welfareapi/search_fondo/@term/',

        // Verifica la presenza del popup informativo da visualizzare in apertura di interfaccia
        info_popup : '/api/welfareapi/info_popup/',

        // Gestisce il pin di identificazione dell'utente loggato, può operare
        // in GET e POST.
        // GET: Torna un flag "pin_exists" che indica se l'utente loggato ha
        //      un pin identificativo associato ( true : se esiste - false : se non esiste )
        // POST:Genera il pin per l'utente loggato, se l'utente già disponeva di un
        //      pin valido il precedente viene annullato. Torna un 204 NO Content
        //      se la generazione va a buon fine.
        pin_identificativo : '/api/welfareapi/pin_identificativo/',

        // Torna le aziende per le quali il referente aziendale può scegliere di
        // visualizzare i dati.
        aziende_referente : '/api/welfareapi/aziende_referente/',

        // Torna le anagrafiche di tutti gli utenti appartenenti all'azienda
        // che il referente aziendale sta visualizzando.
        // Può essere passato il parametro "solo_attivi" alla get il quale se è ad 1
        // restituisce i soli utenti NON cessati, se mancante o posto a 0, torna invece
        // tutti gli utenti dell'azienda
        anagrafica_utenti_by_azienda: '/api/welfareapi/utenti_by_azienda/',

        // Reset della password di un dipendente da parte del referente aziendale.
        reset_password_dipendente:"/api/welfareapi/reset_password_dipendente/",

        // Reset del codice 2FA di un dipendente da parte del referente aziendale.
        reset_otp_dipendente:"/api/welfareapi/reset_otp_dipendente/",

        // Invio dell'email di primo accesso ad un dipendente da parte del referente aziendale.
        email_primo_accesso_dipendente:"/api/welfareapi/email_primo_accesso_dipendente/",

        // Torna i crediti in essere e lo stato di quest'ultimi alla data
        // odierna per tutti i dipendenti dell'azienda che il referente aziendale
        // sta visualizzando
        get_scadenzario_aziendale : '/api/welfareapi/get_scadenzario_aziendale/',

        //momentaneo piani welfare
        get_piani_welfare : '/api/welfareapi/get_piani_welfare/',

        // Torna lo stato del conto anticipi dell'azienda per la quale il referente
        // aziendale sta operando, al momento torna il solo saldo_anticipi
        get_status_conto_anticipi : '/api/welfareapi/get_status_conto_anticipi/',

        // Esegue l'export del welfarebridge di fine mese per i cedolini paghe.
        // Può essere eseguito solo da un referente aziendale accedendo alla sua
        // area.
        export_welfarebridge_fine_mese : '/api/welfareapi/export_wfbridge_fine_mese/',

        // Porting dell'export liwe "Crediti Residui Singoli Utenti per Azienda"
        // realizzato per i referenti aziendali. Fa scaricare solo i crediti
        // attualmente attivi, non permette l'inclusione anche dei crediti scaduti
        // come invece può fare il backoffice.
        export_crediti_res_utenti : '/api/welfareapi/export_crediti_res_utenti/',

        // Vista specifica per l'invio della mail di richiesta al backoffice
        // relativa alla sezione Incentive di Toduba.
        // Viene inviata una mail dove si richiede di caricare nell'account
        // del referente una certa cifra in euro da ppter utilizzare pe
        // elargire regali e benefit.
        // Questo tipo di buoni esula copleatamente dal welfarebit e viene
        // gestito interamente da Toduba.
        ricarica_incentive_toduba : '/api/welfareapi/incentive/ricarica_incentive_toduba/',

        // Verifica ed imposta le condizioni di privacy dell'utente.
        // - Chiamata in get restituisce lo stato della privacy dell'utente
        // - Chiamata in post permette di inviare i dati che l'utente imposta per la privacy
        user_privacy : '/api/welfareapi/user_privacy/',

        // Setta l'ok all'informativa sulla previdenza integrativa,
        // chiamata in POST con il flag previdenza_is_ok a True, torna un
        // 204 NO CCONTENT se ok.
        informativa_prevint: '/api/welfareapi/informativa_prev_int/',

        // Carosello - torna le slides del carosello per l'utente loggato
        carosello_get_playlist : '/api/welfareapi/carosello_get_playlist/',

        // Carosello - incrementa il conteggio dei click per la slide il cui id è passato in post
        carosello_click_count : '/api/welfareapi/carosello_click_count/',

        // Skin Grafice - Torna dato il nome del customer, la sua personalizzazione grafica
        // Chiamata in GET, da usare quanto la personalizzazione non è fatta su file ma da
        // un ente esterno per la quale viene memorizzata su db.
        getapiuserskin : '/api/welfareapi/getapiuserskin/@customer/',

        // Acquisti - creazione acquisto rimborso spese
        create_acq_rimbspese : '/api/welfareapi/acqcreate/rimbspese',

        // Acquisti - creazione acquisto rimborso interessi
        create_acq_rimbint : '/api/welfareapi/acqcreate/rimbint',

        // Acquisti - creazione acquisto rimborso art51c3
        create_acq_rimbart51c3 : '/api/welfareapi/acqcreate/rimbart51c3',

        // Acquisti - creazione acquisto rimborso per affitto o mutuo
        create_acq_rimbaffmutuo : '/api/welfareapi/acqcreate/rimbaffmutuo',

        // Acquisti - creazione acquisto preventivo on demand
        create_acq_prevondemand : '/api/welfareapi/acqcreate/prevondemand',

        // Acquisti - creazione acquisto previdenza integrativa
        create_acq_prevint : '/api/welfareapi/acqcreate/prevint',

        // Acquisto - creazione di un acquisto in convenzione WfBit.
        // Procediamo con un acquisto del tipo convenzione, richiede
        // che siano passati in post tre dati:
        // - id_articolo: id dell'articolo che si sta acquistando
        // - id_fornitore: id del fornitore che sta vendendo l'articolo
        // - codice_articolo: codice dell'articolo che si sta acquistando
        create_acq_convwfbit: '/api/welfareapi/acqcreate/convwfbit',

        // Acquisto - creazione di un acquisto di tipo buono da consorzio WfBit
        // Procediamo con un acquisto di un buono welfarebit spendibile su tutti
        // i fornitori del consorzio.
        // Richiede che siano passati in post i dati:
        // - id_consorzio: id del consorzio presso il quale stiamo acquistando
        // - importo: importo del buono richiesto
        create_acq_buonowfbit: '/api/welfareapi/acqcreate/buonowfbit',

        // Acquisto - torna i tagli dei buoni a disposizione per voucher welfarebit
        get_tagli_buoni_wfbit: '/api/welfareapi/acqcreate/get_tagli_buoni_wfbit',

        // Acquisto - login tantosvago
        // Url di login di tantosvago, richiede di passare tre parametri in POST:
        // - cluster: si trata di uno dei cluster disponibili da richiedere
        // - comp_credito: componente di credito utente da comunicare per la disponibilità utente
        // - service: tipo di servizio richiesto tra quelli disponibili
        create_acq_ts_login: '/api/welfareapi/acqcreate/ts_login',

        // Acquisto - login wishlist in modalità SSO
        create_acq_wishlist_login: '/api/welfareapi/acqcreate/wishlist_login',

        // Acquisto - acquisto di un buono Amilon
        // Post per procedere all'acquisto del buono Amilon desiderato.
        // Inviare in POST il dato:
        // - product_code : codice identificativo del prodotto da acquistare
        create_acq_amilon: '/api/welfareapi/acqcreate/amilon',

        // Acquisto - acquisto del bonus benzina
        // Post per procedere all'acquisto della scheda Benzina Desiderata
        // Inviare in POST il dato:
        // - product_code : codice identificativo del prodotto da acquistare
        create_acq_amilon_bonus_benzina : '/api/welfareapi/acqcreate/amilon_bonus_benzina',

        // Acquisto - acquisto sussidio Eurete
        // Post per procedere all'acquisto di un sussidio Eurete.
        // Inviare in POST il dato:
        // product_slug : slug name del sussidio da acquistare
        create_acq_eurete: '/api/welfareapi/acqcreate/eurete',
        create_acq_eurete_ass_san: '/api/welfareapi/acqcreate/eurete_ass_san',

        // Acquisto - login fano al centro
        // Permette di avere i dati di login in SSO per il portale di Fano Al Centro
        create_acq_fac_login: '/api/welfareapi/acqcreate/fac_login',

        // Acquisto - login MBA
        // Permette di avere i dati di login in SSO per il portale di MBA
        create_acq_mba_login: '/api/welfareapi/acqcreate/mba_login',

        // Acquisto - login SaluteSemplice
        // Permette di avere i dati di login in SSO per il portale di SaluteSemplice
        create_acq_salute_semplice_login: '/api/welfareapi/acqcreate/salute_semplice_login',

        // Acquisto - login per BitQ
        // Permette di avere i dati di login in SSO per il portale di BitQ
        create_acq_bitq_login: '/api/welfareapi/acqcreate/bitq_login',

        // Acquisto - login per Salabam
        // Permette di avere i dati di login in SSO per il portale di Salabam
        create_acq_salabam_login: '/api/welfareapi/acqcreate/salabam_login',

        // Acquisto - Ollipay buono Welfare di marca
        // Permette di effettuare l'acquisto di un buono welfare di marca Ollipay
        create_acq_ollipay_wfm_voucher: '/api/welfareapi/acqcreate/ollipay_wfm_voucher',

        // Acquisto - Toduba buono spesa
        // Permette di effettuare l'acquisto di un buono spesa Toduba
        create_acq_toduba_voucher: '/api/welfareapi/acqcreate/toduba_endpoint',
        // Permette di scaricare i tagli del buono spesa Toduba
        create_acq_tagli_buoni_toduba: '/api/welfareapi/acqcreate/get_tagli_buoni_toduba',

        // Acquisto - amilon100
        // Permette di effettuare l'acquisto di un servizio di convenzion amilon art 100
        create_acq_amilon100_login: '/api/welfareapi/acqcreate/amilon100_login',

        // Acquisto - Login Bonusx
        // Anche se non è una chiamata per effettuare acquisti è stata posta sotto l'url
        // acqcreate per tenerla semanticamente insieme agli altri fornitori.
        // Permette di avere indietro l'url di accesso autenticato a bonusx in base
        // al piano di servizio impostato dal backoffice per l'azienda di cui l'utente
        // fa parte.
        create_acq_bonusx_login : '/api/welfareapi/acqcreate/bonusx_login',

        // Acquisti - andiamo a prendere le informazioni complete riguardo un acquisto
        // l'acquisto ricercato deve appartenere all'utente loggato.
        acq_info_full : '/api/welfareapi/acqinfofull/@id_acquisto/',

        // Acquisti - andiamo a prendere la lista degli acquisti annullati
        // la vista usa un paginatore quindi è possibile usare le querystring
        // page e page_size per avere rispettivamente una determinata pagina
        // ed il numero massimo di elementi per pagina.
        acqcanceled : '/api/welfareapi/acqcanceled/'

    },

    // Api di gestione dei documenti
    documentsapi : {

        // Lista di tutte le tipologie di documento
        lista_doc_tipi : '/api/documentsapi/file_kind_list/',

        // Ricerca tipologie documento per kind
        lista_doc_per_tipo : '/api/documentsapi/file_kind_list/@kind/',

        // Upload documenti allegati agli acquisti
        upload_allegato : '/api/documentsapi/upload_allegato/',

        // Cancellazione dei documenti allegati ( doc id è l'id della doc_documento )
        delete_allegato : '/api/documentsapi/delete_allegato/@doc_id/',

        // Ottenimento dei files caricati da un utente
        get_user_document_list : '/api/documentsapi/get_user_document_list/',

        // Scaricamento di un documento appartenente ad un utente
        download_document : '/api/documentsapi/download_document/@id_resource/',

        // Lista documenti per referente aziendale: torna i documenti degli
        // utenti delle aziende gestite dal referente aziendale, si deve
        // passare in get lo uid dell'utente che ci interessa.
        ref_user_document_list : '/api/documentsapi/ref_user_document_list/',

        // Scaricamento docimenti specifico per il referente aziendale,
        // permette il donwload solo per i documenti relativi alle aziende
        // gestite dal referente.
        ref_user_download_document : '/api/documentsapi/ref_user_download_document/@id_resource/',

        // Lista dei files già caricati per un dato tipo di un utente
        get_file_esistenti: '/api/documentsapi/file_esistenti_list/@kind/',

        // Upload di un file già esistente come nuovo per l'inclusione a nuovo
        // acquisto. SI tratta di un arichiesta POST al quale passare il parametro
        // id_documento
        clona_allegato_esistente: '/api/documentsapi/clona_allegato_esistente/'

    },

    // Api di gestione dei fornitori
    fornitoriapi : {

        //  Torna le anagrafiche estese dei fornitori prendendo solo
        //  quelli abilitari per l'azienda di cui l'utente loggato
        //  fa parte.
        //  Il fornitore è presente in lista se:
        //  - ha almeno pubblicato un articolo
        //  - ha accesso al sistema
        //  - ha degli articoli marchiati come pubblicati da lui ed
        //    approvati dal backoffice
        //  - la data odierna deve ricadere nell'intervallo di decor-
        //    renza/scadenza della pubblicazione dell'articolo.
        //  Alternativamente è possibile avere la lista dei fornitori
        //  associati all'azienda senza l'applicazione di tali condizioni
        //  passando alla get la querystring nofilter=true
        get_fornitori_disponibili : '/api/sellerapi/get_fornitori_disponibili/',

        // Torna tutte le categorie merceologiche a disposizione
        get_categorie : '/api/sellerapi/get_categorie/',

        // Torna le info di anagrafica estesa di un singolo fornitore, questo deve
        // però rientrare tra quelli disponibili per l'azienda dell'utente
        get_info_fornitore : '/api/sellerapi/get_info_fornitore/@id_fornitore/',

        // Torna le informazioni su di uno specifico articolo. L'articolo deve
        // appartenere ad un fornitore che rientra tra quelli per l'azienda
        // dell'utente.
        get_info_articolo: '/api/sellerapi/get_info_articolo/@id_articolo/',

        // Torna i fornitori afferenti al consozio il cui id viene passato nell'url.
        // Il consorzio deve essere permissionato per l'azienda dell'utente che
        // fa la richiesta.
        get_forn_by_consorzio: '/api/sellerapi/get_forn_by_consorzio/@id_consorzio/',

        // Torna la vetrina dei prodotti di un fornitore, solo le vetrine dei fornitori
        // abilitati per l'azienda dell'utente loggato possono essere visualizzate
        get_vetrina : '/api/sellerapi/get_vetrina/@id_fornitore/',

        // Torna la lista dei voucher che l'utente ha comperato. La vista supporta
        // la paginazione.
        get_user_voucher_list: '/api/sellerapi/get_user_voucher_list/'

    },

    // Api per Piattapasto
    piattapastoapi : {

        // Gestisce i settings per piattapasto relativamente all'azienda,
        // in base alla chiamata abbiamo:
        // POST: aggiunge i settings per l'azienda dell'utente
        //       loggato, se il valore già esiste ne fa l'update
        // GET: torna i settings per l'azienda dell'utente
        //      loggato.
        // DELETE: cancella i settings per l'azienda dell'utente
        //         loggato.
        pp_settings: '/api/piattapastoapi/pp_settings/',

        // Permtte di caricare il cvs con l'ordine piattapasto da
        // effettuare. Se il csv è formalmente corretto, gli ute-
        // nti esistono ed hanno sufficiente credito per fare
        // l'ordine allora questo viene posto nella tabella degli
        // ordini Piattapasto in attesa di essere validato
        // dall'utente ed essere quindi eseguito.
        // La chiamata è un POST con il solo parametro
        // "csv_ordine". Se tutto ok torna il json con il report
        // dell'ordine da eseguire e l'id dell'ordine stesso per
        // poterlo validare.
        upload_csv_ordine: '/api/piattapastoapi/upload_csv_ordine/',

        // Permette di scaricare il template con gli utenti dell'azienda
        // che il referente aziendale sta gestendo, da utilizzare per
        // effettuare l'ordine piattapasto.
        // Il tempalte contiene 4 colonne:
        // - A: Nome e cognome del dipendente
        // - B: Email del dipendente
        // - C: Numero buoni pasto ( posto di default a zero )
        // - D: Credito residuo totale
        download_template_csv_ordine: '/api/piattapastoapi/download_template_csv_ordine/',

        // La vista permette di confermare od annullare un ordine
        // precedentemente caricato tramite csv.
        // Può operare in POST o in DELETE.
        // POST:  l'ordine viene confermato e quindi viene avviata la
        //        procedura di acquisto vera e propria che mette a
        //        sistema le pratiche welfare per i buoni richiesti.
        // DELETE:l'ordine non viene confermato ed è quindi rimosso
        //        dalla tabella degli ordini.
        // In entrambi i casi deve essere passato il parametro
        // "id_ordine" per identificare l'ordine da confermare
        // od annullare.
        conferma_annulla_ordine: '/api/piattapastoapi/conferma_annulla_ordine/',

        // Vista che restituisce lo stato degli ordini per l'azienda per
        // la quale ilr eferente aziendale sta operando.
        // Si tratta di una GET con paginatore per questo usa i parametri
        // page e page_size della querystring.
        storico_ordini : '/api/piattapastoapi/storico_ordini/',
    },

    // Api per Amilon
    amilonapi : {

        // GET: Torna la lista dei venditori Amilon disponibili da contratto
        // la get accetta i parametri page_size e page nella query string
        // operando con il paginatore di djangorest.
        get_retailers: '/api/amilonapi/get_retailers/?page_size=1000',

        // GET: Torna la lista completa dei prodotti Amilon disponibili da contratto
        // la get accetta i parametri page_size e page nella query string
        // operando con il paginatore di djangorest.
        get_all_products: '/api/amilonapi/get_products/',

        // GET: Torna la lista dei prodotti Amilon relativamente
        // ad uno specifico mercante ( fornitore ), il cui codice
        // deve essere passato nell'url.
        // La get accetta i parametri page_size e page nella query string
        // operando con il paginatore di djangorest.
        get_products_by_merchant: '/api/amilonapi/get_products/@merchant_code/',

        // GET per avere la card Amilon cui l'utente ha diritto per il
        // bonus benzina 2022. Torna la card il cui taglio più si avvicina
        // a quanto spendibile con il credito utente a disposizione.
        // Se l'utente ha già fatto l'acquisto o non ha sufficiente credito,
        // torna un 204_NO_CONTENT
        get_bonus_benzina_card: '/api/amilonapi/get_bonus_benzina_card/'

    },

    // Api per Eurete
    eureteapi : {

        // GET: Torna la lista delle sezioni nella quale si dividono i sussidi assicurativi
        // di Eurete la get accetta i parametri page_size e page nella query string
        // operando con il paginatore di djangorest.
        get_sezioni : '/api/eureteapi/get_sezioni/',

        // GET: Torna le informazioni descrittive di una ben precisa sezione il cui slug
        // è passato nell'url.
        get_info_sezione : '/api/eureteapi/get_info_sezione/@slug_name/',

        // GET: Torna i prodotti, cioè i sussidi relativi alla sezione il cui slug è passato
        // nell'url. La get accetta i parametri page_size e page nella query string
        // operando con il paginatore di djangorest.
        get_prodotti_by_sezione : '/api/eureteapi/get_prodotti_by_sezione/@slug_name/',

        // GET: Torna il link compilato in tutte le sue payload al sso di Eurete .
        get_sso_link : '/api/eureteapi/get_sso_link/',

    },

    importtoolapi: {
        importtools: '/api/importtoolapi/importtools/',
        cancel_import: '/api/importtoolapi/importtools/@import_id/cancel/',
    },

    // API di gestione della Conversione Premio
    conversionepremioapi: {

        // GET: elenco delle campagne e dettaglio della scelta del dipendente
        // POST: creazione di una campagna e salvataggio della scelta del dipendente
        // PUT/PATCH: modifica della campagna e cambio di stato
        campagne: '/api/conversionepremioapi/campagne/',

        // GET: recupera la campagna disponibile per il dipendente autenticato
        // Priorità alle campagne PUBBLICATO, altrimenti CHIUSO
        dipendente_campagna: '/api/conversionepremioapi/dipendente/campagna/',

    }
}

export { apiUrl };
